import {FamilyMemberType} from '@services/family/family.constants';
import {logger} from '@utils';
import {SagaIterator} from 'redux-saga';
import {put, select} from 'redux-saga/effects';
import * as UserActions from '../user/user.actions';
import * as FamilyWebsocket from './family.websocket';
import {IFamilyMember} from '@app-types/websocket/family.types';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { enrichFamilySuccess } from './family.actions';
import { standardFamilyColors, enrichFamilyData } from './family.utils';

// combines data from family and calendarsettings (colors)
export function* enrichFamily(action: any) {

  const familyState:IFamilyMember[] | undefined = yield select((state:any) => state?.family?.familyUncolor);
  const calendarState:ICalendarSetting | undefined = yield select((state:any) => state?.user?.calendarSettings);

  // Persisted state can hold null or old shapes; an uncaught throw here would
  // take down the whole saga tree, so only trust arrays.
  const familyColors = calendarState && Array.isArray(calendarState.familyColors) ? calendarState.familyColors : [];

  if (Array.isArray(familyState) && familyState.length > 0) {


      const fColors:string[] = standardFamilyColors.slice();

      for (let index = 0; index < familyColors.length; index++) {
        if (fColors.length > index) {
          fColors[index] = familyColors[index];
        } else {
          fColors.push(familyColors[index]);
        }
      }

      yield put(enrichFamilySuccess(enrichFamilyData(familyState, fColors)));
  }
}

export function* signupAddFamilyMember(action: any): SagaIterator {
  try {

    const body = {
      ...action.payload,
      role: FamilyMemberType.PARENT,
      sex:'UNKNOWN',
    };

    FamilyWebsocket.addNewFamilyMember(body);

    yield put(UserActions.onboardingSetActiveStep(1));
  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error adding other parent: "+error.message));
  }
}



export function* signupAddChild(action: any): SagaIterator {
  try {
    const { childs }:any = action.payload;

    const data = childs.map((child: any) => {
      return {
        ...child,
        role: FamilyMemberType.CHILD,
        sex: 'UNKNOWN',
      };
    });

    data.forEach((child: any) => {
      FamilyWebsocket.addNewFamilyMember(child);
    });

    yield put(UserActions.onboardingSetActiveStep(2));
  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error adding child: "+error.message));
  }
}

export function* addFamilyMember(action: any): SagaIterator {
  try {

    const member:IFamilyMember = {
        ...action.payload,
      sex: 'UNKNOWN',
    };

    if (!member.role) {
      member.role = FamilyMemberType.CHILD;
    }

    FamilyWebsocket.addNewFamilyMember(member);
  } catch (error) {
    logger.info(error);
  }
}

export function* addUser(action: any): SagaIterator {
  try {

    const member:IFamilyMember = {
        ...action.payload,
      sex: 'UNKNOWN',
    };

    FamilyWebsocket.addUser(member);
  } catch (error) {
    logger.info(error);
  }
}

export function* updateFamilyMember(action: any): SagaIterator {
  try {

    FamilyWebsocket.updateFamilyMember(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error updating family member: "+error.message));
  }
}

export function* updateFamilyMemberFileId(action: any): SagaIterator {
  try {

    FamilyWebsocket.updateFamilyMemberFileId(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error updating family member file Id: "+error.message));
  }
}

export function* deleteFamilyMember(action: any): SagaIterator {
  try {

    FamilyWebsocket.deleteFamilyMember(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error updating family member: "+error.message));
  }
}

export function* unlimitFamilyMember(action: any): SagaIterator {
  try {

    FamilyWebsocket.unlimitFamilyMember(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error lifting family member limit: "+error.message));
  }
}

export function* restoreAccount(action: any): SagaIterator {
  try {

    FamilyWebsocket.restoreAccount(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error restoring account: "+error.message));
  }
}

export function* nudgeToLogIn(action: any): SagaIterator {
  try {

    FamilyWebsocket.nudgeToLogIn(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error nudging user to log in: "+error.message));
  }
}

export function* selectFamilyCountry(action: any): SagaIterator {
  try {

    FamilyWebsocket.selectFamilyCountry(action.payload);

  } catch (error) {
    yield put(UserActions.displayErrorMessage("Error updating family country: "+error.message));
  }
}

export function* createFamily(action: any): SagaIterator {
  try {
    FamilyWebsocket.createFamily(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

export function* updateChildInfo(action: any): SagaIterator {
  try {
    FamilyWebsocket.updateChildInfo(action.payload);
  } catch (error) {
    logger.info(error);
  }
}



// WEBPACK FOOTER //
// ./src/services/family/family.saga.ts